module.exports = __webpack_public_path__ + "static/img/2.5d77269.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/2.png
// module id = IAbt
// module chunks = 0